import { lazy } from "react";
import { isChunkLoadError } from "components/shared/ChunkLoadErrorBoundary";

const CHUNK_RELOAD_KEY = "chunk_fail_reload";

/**
 * Wraps a dynamic import so that chunk load errors (e.g. after new deployment)
 * trigger one automatic page reload. Prevents "Blank page / Missing JS chunk".
 */
export function lazyWithChunkRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (isChunkLoadError(error)) {
        const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
        if (!alreadyReloaded) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
          window.location.reload();
          return new Promise(() => {}); // never resolve so UI doesn't update mid-reload
        }
      }
      throw error;
    })
  );
}
